import script from "./DialogDike.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDike.vue?vue&type=script&setup=true&lang=ts"

import "./DialogDike.vue?vue&type=style&index=0&id=54fc2fc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54fc2fc2"]])

export default __exports__